<script>
  // Lightweight modal (replaces react-bootstrap Modal). Closes on backdrop click or Escape.
  //
  // A modal holding work the user cannot re-enter in a second (the dashboard's create-payment-link
  // wizard, with its uploaded compliance documents) passes `onDismiss` to intercept those two casual
  // routes out; the explicit Close button always calls `onClose`. Without `onDismiss` the two are the
  // same, which is what every other modal wants.
  let { title = "", onClose, onDismiss, children, footer } = $props();

  const dismiss = () => (onDismiss ?? onClose)?.();

  function onKey(e) {
    if (e.key === "Escape") dismiss();
  }

  // A click only counts as "outside" when the press *started* outside too. A click event fires on the
  // nearest common ancestor of its mousedown and mouseup, so selecting text inside the modal and
  // releasing over the backdrop used to land on the backdrop and throw the form away. Same for the
  // click that merely refocuses a background browser window on another monitor.
  let pressedOutside = false;
  const onBackdropPress = (e) => (pressedOutside = e.target === e.currentTarget);

  function onBackdropClick(e) {
    const outside = e.target === e.currentTarget && pressedOutside;
    pressedOutside = false;
    if (outside) dismiss();
  }
</script>

<svelte:window on:keydown={onKey} />

<div class="backdrop" onmousedown={onBackdropPress} onclick={onBackdropClick} role="presentation">
  <div class="modal" role="dialog" aria-modal="true">
    <div class="modal-head">
      <span class="modal-title">{title}</span>
      <button class="close" onclick={() => onClose?.()} aria-label="Close">×</button>
    </div>
    <div class="modal-body">{@render children()}</div>
    {#if footer}<div class="modal-foot">{@render footer()}</div>{/if}
  </div>
</div>

<style>
  .backdrop { position: fixed; inset: 0; background: rgba(8, 12, 18, 0.55); display: flex; align-items: flex-start; justify-content: center; padding: 48px 16px; z-index: 100; overflow-y: auto; }
  /* The body scrolls, not the whole dialog: a long form (the payment-link wizard) must never push its
     own footer below the fold, or the primary button — and the error rendered beside it — are simply
     not on screen when the user goes looking for them. */
  .modal { background: var(--card-bg); border: 1px solid var(--border); border-radius: 12px; box-shadow: 0 12px 40px rgba(0,0,0,0.3); width: 100%; max-width: 640px; display: flex; flex-direction: column; max-height: calc(100vh - 96px); }
  .modal-head { display: flex; align-items: center; padding: 16px 20px; border-bottom: 1px solid var(--border); flex: none; }
  .modal-title { font-weight: 600; font-size: 16px; margin-right: auto; }
  .close { background: none; border: none; color: var(--muted); font-size: 24px; line-height: 1; cursor: pointer; }
  .modal-body { padding: 20px; overflow-y: auto; }
  .modal-foot { padding: 14px 20px; border-top: 1px solid var(--border); display: flex; gap: 8px; justify-content: flex-end; align-items: center; flex-wrap: wrap; flex: none; }
</style>
